<template>
  <div class="mainContainer pl-0" v-if="configurator.currentSubsystemStepComponent">
    <div class="pl-12">
      <v-scroll-y-transition>
        <v-overlay :value="highlightHint" opacity=".8"></v-overlay>
      </v-scroll-y-transition>
      <v-row>
        <v-col cols="8"><breadcrumbs /></v-col>
        <v-col class="pt-5 text-right" v-show="hasSettings && !hasProducts">
          <v-btn
            class="text-capitalize textEmphasis mr-2"
            text
            rounded
            @click="openProject(configurator.currentProject.id)"
            >Exit to Project</v-btn
          >
          <v-btn
            rounded
            color="#E1D4F7"
            class="text-capitalize sigfloButtonSmall600 elevation-0"
            @click="saveSubsystemStepProgress('subsystem')"
            >Save progress</v-btn
          >
        </v-col>
      </v-row>
      <subsystem-header />
      <v-divider v-if="hasProducts" />
      <product-container-header v-if="hasProducts" />
      <!-- Settings -->
      <settings-container />
      <!-- Products -->
      <v-fade-transition mode="out-in">
        <selected-product-container />
      </v-fade-transition>
      <v-fade-transition mode="out-in">
        <product-grid-container />
      </v-fade-transition>
      <v-spacer />
    </div>
    <!-- Footer -->
    <footer-progress-bar v-show="showProgressBar" :steps="steps" class="footerBar"></footer-progress-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import footerProgressBar from '@/components/configurator/subsystem/FooterProgressBar';
  import settingsContainer from '@/components/configurator/subsystem/SettingsContainer';
  import breadcrumbs from '@/components/configurator/subsystem/Breadcrumbs';
  import subsystemHeader from '@/components/configurator/subsystem/SubsystemHeader';
  import selectedProductContainer from '@/components/configurator/subsystem/SelectedProductContainer';
  import productGridContainer from '@/components/configurator/subsystem/ProductGridContainer';
  import productContainerHeader from '@/components/configurator/subsystem/ProductContainerHeader';

  export default {
    components: {
      footerProgressBar,
      settingsContainer,
      breadcrumbs,
      subsystemHeader,
      selectedProductContainer,
      productGridContainer,
      productContainerHeader
    },
    created() {
      // handle navigation events
      this.$eventBus.$on('component-step-navigation', () => {
        if (this.hasSettings && this.$refs.settingsForm) {
          this.$refs.settingsForm.validate();
        }
      });
    },
    mounted: function () {
      if (!this.configurator.currentProject || !this.configurator.currentSystem || !this.configurator.currentSubsystem)
        this.navToProjectPage();
    },
    methods: {},
    computed: {
      ...mapState(['configurator', 'navigation']),
      showProgressBar: function () {
        return (
          this.$route.name === 'subsystem' &&
          this.configurator.currentSubsystem &&
          this.configurator.currentSubsystemSteps &&
          this.configurator.currentSubsystemSteps.length > 0
        );
      },
      steps: {
        set() {},
        get() {
          return this.configurator.currentSubsystemSteps;
        }
      }
    },
    data() {
      return {
        highlightHint: false,
        showSteps: false
      };
    }
  };
</script>

<style scoped>
  .subsystemHeaderText {
    line-height: 1rem;
  }

  .footerBar {
    position: fixed;
    bottom: 0px;
    z-index: 2;
  }

  .cursor {
    cursor: pointer;
  }

  .mainContainer {
    padding-bottom: 85px;
    width: 100vw;
    max-width: 1600px;
  }

  .avlHint {
    z-index: 99;
  }
  .subtotal {
    font-weight: bold;
    color: gray;
    margin-right: 15px;
  }

  .subsystemHeaderTotal {
    margin-right: -10px;
    padding-left: 30px;
    padding-right: 5px;
    background-color: #f2f2f2;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }
</style>
